var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDotdotdotHorizontal = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 3.368,
    viewBox: "0 0 14 3.368",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-667.844 -4401)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.684,
    cy: 1.684,
    r: 1.684,
    transform: "translate(673.16 4401)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.684,
    cy: 1.684,
    r: 1.684,
    transform: "translate(678.475 4401)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.684,
    cy: 1.684,
    r: 1.684,
    transform: "translate(667.844 4401)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDotdotdotHorizontal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dotdotdot-horizontal.1c6175dd08410e2afd7c8503c3053d8c.svg";